export default "__VITE_ASSET__CRNb3Aqo__"